import { Group, Paper, Text } from "@mantine/core";
import { useIsSmallViewport } from "hooks/useIsSmallViewport";
import { Tooltip } from "react-leaflet";
import {
  useChartTooltipData,
  useHoveredTrackpoint,
} from "stores/genericStore/GenericContext";

import { TrackPointMarker } from "./TrackPointMarker";
import "./ChartMarkerStyleReset.css";
import { useRouting } from "stores/routingStore/RoutingContext";
import classes from "./ChartMarker.module.css";

export const ChartMarker = () => {
  const chartTooltipData = useChartTooltipData();
  const hoveredTrackpoint = useHoveredTrackpoint();
  const isSmallViewport = useIsSmallViewport();
  const {
    state: { trackWaypoints },
  } = useRouting();

  // Hovering the track line shows the same marker without the values (TrackHover), the chart shows them
  if (hoveredTrackpoint) return null;

  return chartTooltipData &&
    ((!isSmallViewport && chartTooltipData?.isHovered) ||
      (isSmallViewport && trackWaypoints.length > 1)) ? (
    <TrackPointMarker position={chartTooltipData.position}>
      <Tooltip
        permanent={true}
        direction="top"
        // Above the circle (its radius with the ring) and the tooltip's arrow
        offset={[0, -16]}
        opacity={1}
        className="leaflet-tooltip-reset"
      >
        <Paper py={4} px={10} className={classes.label}>
          <Group gap={0} style={{ justifyContent: "center" }}>
            <Text size="xs">{chartTooltipData.xAxisString}</Text>
            <Text size="xs">{chartTooltipData.yAxisString}</Text>
          </Group>
        </Paper>
      </Tooltip>
    </TrackPointMarker>
  ) : null;
};
